module.exports = __webpack_public_path__ + "img/odt.82e35dac.svg";